import split from '@os/split-point';
import load from 'bundle-loader?lazy&name=dynamic-stock-chart!./full-dynamic-stock-chart';

export default split(load);



// WEBPACK FOOTER //
// ../node_modules/@cube/finance-components/src/components/dynamic-stock-chart/index.js